import React from 'react';

type TabType = 'ALL' | 'MATCHED' | 'NEGATIVE';

interface FilterBarProps {
  tickerInput: string;
  setTickerInput: (value: string) => void;
  startDateInput: string;
  setStartDateInput: (value: string) => void;
  endDateInput: string;
  setEndDateInput: (value: string) => void;
  isFilterOpen: boolean;
  setIsFilterOpen: (open: boolean) => void;
  onFilterSubmit: (e: React.FormEvent) => void;
  onClear: () => void;
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

export const FilterBar: React.FC<FilterBarProps> = ({
  tickerInput, setTickerInput, 
  startDateInput, setStartDateInput, 
  endDateInput, setEndDateInput,
  isFilterOpen, setIsFilterOpen, onFilterSubmit, onClear
}) => {
  // יוצרים משתנה של התאריך של היום כדי לחסום תאריכים עתידיים
  const todayStr = new Date().toISOString().split('T')[0];

  return (
    <div className={`
      fixed inset-y-0 right-0 z-50 w-72 bg-white dark:bg-[#0e1624] border-l border-gray-200 dark:border-[#1d2d47]
      p-6 shadow-2xl transition-transform duration-300
      ${isFilterOpen ? 'translate-x-0' : 'translate-x-full'}
      lg:static lg:translate-x-0 lg:w-full lg:p-0 lg:border-none lg:shadow-none lg:block shrink-0
    `}>
      <div className="flex justify-end lg:hidden mb-4">
        <button onClick={() => setIsFilterOpen(false)} className="text-[11px] font-semibold text-gray-500 dark:text-[#c2d0e0] hover:text-gray-900 dark:hover:text-[#f1f5fb] uppercase tracking-widest">
          ✕ Close
        </button>
      </div>

<div className="rounded-2xl border border-gray-200 dark:border-[#1d2d47] bg-white dark:bg-[#0e1624] overflow-hidden shadow-sm">        <div className="h-[3px] bg-gradient-to-r from-[#f5a623] via-[#f97316] to-[#4f8ff8]" />
        <div className="p-5 flex flex-col gap-4">
          <h2 className="text-[11px] font-bold text-gray-500 dark:text-[#a3b6cc] uppercase tracking-[0.15em]">Filter Events</h2>

          <div className="flex flex-col gap-1.5">
            <label className="text-[10.5px] font-semibold text-gray-400 dark:text-[#a3b6cc] uppercase tracking-[0.1em]">Ticker</label>
            <input
              type="text"
              value={tickerInput}
              onChange={e => setTickerInput(e.target.value)}
             placeholder="e.g. NVDA · empty = all"
              className="w-full bg-gray-50 dark:bg-[#141e30] border border-gray-200 dark:border-[#1d2d47] rounded-xl px-3 py-2.5 text-[12px] text-gray-800 dark:text-[#f1f5fb] placeholder-gray-400 dark:placeholder-cat-text-dark focus:border-[#4f8ff8] focus:outline-none transition-colors uppercase"
/>
          </div>

         {/* ── אזור טווח התאריכים המאוחד ── */}
          <div className="flex flex-col gap-2 p-3 bg-gray-50/50 dark:bg-white/[0.02] border border-gray-100 dark:border-white/5 rounded-xl">
            <label className="text-[10.5px] font-semibold text-gray-400 dark:text-cat-text-dark uppercase tracking-[0.1em]">Date Range</label>
            <div className="flex items-center bg-white dark:bg-[#141e30] border border-gray-200 dark:border-cat-border rounded-xl overflow-hidden focus-within:border-cat-accent focus-within:ring-1 focus-within:ring-cat-accent transition-all dark:[color-scheme:dark]">
              <input
                type="date"
                value={startDateInput}
                max={endDateInput || todayStr} 
                onChange={e => setStartDateInput(e.target.value)}
                className="w-full bg-transparent px-2 py-2.5 text-[11px] text-gray-800 dark:text-cat-text-main focus:outline-none"
              />
              <span className="text-gray-400 dark:text-cat-text-dark px-1 text-[9px] font-bold font-mono">TO</span>
              <input
                type="date"
                value={endDateInput}
                max={todayStr}
                min={startDateInput}
                onChange={e => setEndDateInput(e.target.value)}
                className="w-full bg-transparent px-2 py-2.5 text-[11px] text-gray-800 dark:text-cat-text-main focus:outline-none"
              />
            </div>
            
            {/* כפתור ה-Apply מוצמד ויזואלית רק לתאריכים */}
            <button 
              type="button" 
              onClick={onFilterSubmit} 
              className="mt-1 w-full bg-cat-accent/10 hover:bg-cat-accent/20 text-cat-accent dark:text-[#4f8ff8] py-2 rounded-lg text-[11px] font-bold uppercase tracking-wide transition-colors"
            >
              Apply Dates
            </button>
          </div>
         {/* ── לחצן ניקוי מסננים כללי בתחתית הפאנל ── */}
          <div className="pt-2 border-t border-gray-100 dark:border-[#1d2d47]">
            <button 
              type="button" 
              onClick={onClear} 
              className="w-full bg-gray-100 dark:bg-[#141e30] border border-gray-200 dark:border-[#1d2d47] text-gray-600 dark:text-[#c2d0e0] px-4 py-2.5 rounded-xl text-[11px] uppercase tracking-wide font-bold hover:bg-gray-200 dark:hover:bg-[#1a2744] transition-colors"
            >
              Clear All Filters
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};